import { Model } from 'infra/model'
import { Id } from 'types/definitions'
import Workspace from 'iam/models/Workspace'
import { PrimeWorkspace } from 'iam/WorkspaceStore'
import { ProHistoricalTransactionResource } from './dtos/pro-transactions'
import {
  UserTransactionReason,
  parseUserTransactionReason,
} from '../UserTransactionReason'
import { TransactionType, parseTransactionType } from '../TransactionType'
import {
  parseTransactionSourceType,
  TransactionSourceType,
} from '../TransactionSourceType'
import { DateZero, maybeParseDate } from 'utils/date-util'
import Job from '../../jobs/Job'
import { PrimeJob } from '../../jobs/JobStore'

/**
 * A historical payout transaction, from the Pro perspective.
 */
export class ProHistoricalTransaction extends Model<
  ProHistoricalTransactionResource,
  ProHistoricalTransaction
> {
  id: Id
  shortId = ''
  amount = 0
  type = TransactionType.Payment
  workspace = Workspace.none
  source = TransactionSourceType.Unknown
  reason: UserTransactionReason | null = UserTransactionReason.Unknown
  memo: string | null = null
  completedAt = DateZero()
  payoutId: Id | null = null
  stripeAccountId: string | null = null

  job: Job | null = null

  constructor(
    private readonly primeWorkspace: PrimeWorkspace,
    private readonly primeJob: PrimeJob,
  ) {
    super()
  }

  parse(
    attrs: Partial<ProHistoricalTransactionResource>,
  ): Partial<ProHistoricalTransaction> {
    return {
      id: attrs.id,
      shortId: attrs.short_id,
      amount: attrs.amount,
      completedAt: maybeParseDate(attrs.date_completed),
      payoutId: attrs.payout_id,
      stripeAccountId: attrs.stripe_account_id,
      workspace: attrs.workspace_id
        ? this.primeWorkspace({ id: attrs.workspace_id })
        : undefined,
      type: attrs.type && parseTransactionType(attrs.type),
      source: attrs.source && parseTransactionSourceType(attrs.source),
      reason: attrs.reason && parseUserTransactionReason(attrs.reason),
      memo: attrs.memo,
      job:
        attrs.job_id === undefined
          ? undefined
          : attrs.job_id === null
            ? null
            : this.primeJob({
                id: attrs.job_id,
                short_id: attrs.job_short_id ?? undefined,
              }),
    }
  }
}
